import React, { useEffect, useState } from 'react'

export default function GauTalking({ messages, onDone }) {
    const [msgIndex, setMsgIndex] = useState(0);
    const [displayText, setDisplayText] = useState("");

    useEffect(() => {
        if (!messages.length) return;

        const currentMessage = messages[msgIndex];
        let i = 0;

        setDisplayText("");

        const typing = setInterval(() => {
            i++;
            setDisplayText(currentMessage.slice(0, i));

            if (i >= currentMessage.length) {
                clearInterval(typing);

                setTimeout(() => {
                    setMsgIndex((prev) => {
                        if (prev + 1 >= messages.length) {
                            onDone && onDone();
                            return messages.length - 1;
                        }
                        return prev + 1;
                    });
                }, 1000);
            }
        }, 40);

        return () => clearInterval(typing);
    }, [msgIndex, messages, onDone]);


    return <div style={{ position: "relative", display: "inline-block" }}>
        <img alt="Bé Gấu AI" src={process.env.PUBLIC_URL + "/img/gaufull.png"} height={500} />

        {displayText && (
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    right: 40,
                    background: "white",
                    border: "2px solid #333",
                    borderRadius: "20px",
                    padding: "12px 16px",
                    maxWidth: "600px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                    fontSize: "16px",
                    whiteSpace: "pre-line",
                    transform: "translateX(calc(100% - 25px))",
                    zIndex: 100,
                }}
            >
                {displayText}
            </div>
        )}
    </div>
}
